<svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 1C7.4 1 3.33333 6.33333 2 9C3.16667 11.8333 7 17.5 13 17.5C19 17.5 22.8333 11.8333 24 9C22.6667 6.33333 18.6 1 13 1Z" stroke="white" stroke-width="2"/>
    <circle cx="13" cy="9" r="3.25" stroke="white" stroke-width="1.5"/>
</svg>
